import { ArticleHeading1, ArticleHeading2, Button, Modal, Responsive, Input, Textarea, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ReplyTemplateModalEdit.css';

import type { IReplyTemplate } from '../../types/replyTemplates';

type TProps = {
  template: IReplyTemplate;
  isLoading: boolean;
  errorMessage?: string;
  onEdit: (id: number, text: string, name?: string) => void;
  onClose: () => void;
};

export const ReplyTemplateModalEdit: React.FC<TProps> = ({ template, isLoading, errorMessage, onClose, onEdit }) => {
  const [name, setName] = React.useState<string>('');
  const [text, setText] = React.useState<string>('');

  React.useEffect(() => {
    setName(template.name || '');
    setText(template.text);
  }, [template]);

  const onChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const onChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  return (
    <Modal
      open
      size="S"
      onOpenChange={onClose}
      header={
        <>
          <Responsive desktop>
            <ArticleHeading1>Изменение шаблона</ArticleHeading1>
          </Responsive>
          <Responsive phone tablet>
            <ArticleHeading2>Изменение шаблона</ArticleHeading2>
          </Responsive>
        </>
      }
      footer={
        <>
          <Responsive desktop>
            <div className={styles['buttons-desktop']}>
              <Button theme="fill_secondary" size="M" onClick={onClose}>
                Отмена
              </Button>
              <Button
                size="M"
                onClick={() => onEdit(template.id, text, name)}
                disabled={!text.trim()}
                loading={isLoading}
              >
                Сохранить
              </Button>
            </div>
          </Responsive>
          <Responsive phone tablet>
            <div className={styles['buttons-mobile']}>
              <Button theme="fill_secondary" size="M" fullWidth onClick={onClose}>
                Отмена
              </Button>
              <Button
                size="M"
                fullWidth
                onClick={() => onEdit(template.id, text, name)}
                disabled={!text.trim()}
                loading={isLoading}
              >
                Сохранить
              </Button>
            </div>
          </Responsive>
        </>
      }
    >
      <>
        <Responsive desktop>
          <div className={styles['container-desktop']}>
            <Input
              maxLength={40}
              value={name}
              size="M"
              onChange={onChangeName}
              placeholder="Название шаблона (необязательно)"
            />
            <Textarea
              value={text}
              size="M"
              onChange={onChangeText}
              hasCounter
              minRows={5}
              maxRows={10}
              placeholder="Текст шаблона"
              maxLength={1000}
            />
            <UIText2 color="theme-red">{errorMessage}</UIText2>
          </div>
        </Responsive>
        <Responsive phone tablet>
          <div className={styles['container-mobile']}>
            <Input
              maxLength={40}
              value={name}
              size="M"
              onChange={onChangeName}
              placeholder="Название шаблона (необязательно)"
            />
            <Textarea
              value={text}
              size="M"
              onChange={onChangeText}
              hasCounter
              minRows={5}
              maxRows={10}
              placeholder="Текст шаблона"
              maxLength={1000}
            />
            <UIText2 color="theme-red">{errorMessage}</UIText2>
          </div>
        </Responsive>
      </>
    </Modal>
  );
};
